import Axios from "axios";

export default {
    async updatePriceTier(priceTierId, params) {
        let res = await Axios.put(
            `${process.env.BARRAMUNDI}inventory/price-tier/${priceTierId}`,
            params
        );
        if (res && res.data && res.data.response) {
            return res.data.response;
        } else {
            return null;
        }
    },
    async newPriceTier(params) {
        let res = await Axios.post(
            `${process.env.BARRAMUNDI}inventory/price-tier`,
            params
        );
        if (res && res.data && res.data.response) {
            return res.data.response;
        } else {
            return null;
        }
    },
    getPriceTiers(itemId) {
        return Axios.get(
            `${process.env.BARRAMUNDI}inventory/price-tier/${itemId}`
        ).then(res => {
            if (res.data && res.data.response && res.data.response.resources) {
                return res.data.response.resources;
            }
            return [];
        });
    },
    deletePriceTier(priceTierId) {
        return Axios.delete(
            `${process.env.BARRAMUNDI}inventory/price-tier/${priceTierId}`
        ).then(response => response.data);
    }
};
